<ng-container *transloco="let t">
    <section
        fxFlex="100"
        fxFlex.xs="100"
        fxFlex.sm="100"
        fxLayout="column"
        fxLayoutAlign="space-between"
        fxFlexFill
    >
        <h1>{{ t("auth.login.header") }}</h1>

        <form [formGroup]="formGroup" (ngSubmit)="emailOrPhoneSubmitted()">
            <mat-form-field appearance="outline">
                <mat-label>{{ t("auth.login.emailOrPhone") }}</mat-label>
                <input
                    matInput
                    formControlName="emailOrPhone"
                    maxlength="200"
                    cdkFocusInitial
                />
                @if (emailOrPhone?.hasError('required')) {
                <mat-error>
                    {{ t("auth.account-setup.emailOrPhoneRequired") }}
                </mat-error>
                } @if (emailOrPhone?.hasError('invalidEmailOrPhoneNumber')) {
                <mat-error>
                    {{ t("auth.account-setup.invalidEmailOrPhoneNumber") }}
                </mat-error>
                }
            </mat-form-field>

            <!-- Outside the form field: the address is valid when this shows, and a field only
                 renders its mat-error children while its control is invalid. -->
            @if (submitFailed) {
            <mat-error class="submit-failed">
                {{ t("shared.error.submitFailed") }}
            </mat-error>
            }

            <app-busyable-button
                [disabled]="formGroup.invalid"
                [busy]="busy"
                [text]="t('shared.continue') | uppercase"
            ></app-busyable-button>
        </form>
    </section>
</ng-container>
